// Where my voice goes in the spy hut's games (狼人杀, 谁是卧底): the office decides who hears whom (voice.ts hearing(),
// werewolf.ts / spy.ts mayHear) and the page only says so, next to the game's timer. State as data (docs/i18n.md):
//   all    the table hears me (my turn by day / describing, the deal, dawn, 谁是卧底's vote)
//   wolf   at night, the wolves (and the spectators) hear me
//   turn   by day, not my turn: nobody at the table hears me
//   night  at night, not a wolf: nobody hears me
//   vote   狼人杀's vote: nobody talks
//   ghost  out, or watching: only the others out and watching hear me
// muted: my mic is off, while the table (or the wolves) would hear me.
import { put } from '/icons.js';
import { t } from '/i18n.js';

const VOICE = {
  all: { icon: 'mic', text: 'gamevoice.all' },
  wolf: { icon: 'wolf', text: 'gamevoice.wolf' },
  turn: { icon: 'mic_off', text: 'gamevoice.turn' },
  night: { icon: 'mic_off', text: 'gamevoice.night' },
  vote: { icon: 'mic_off', text: 'gamevoice.vote' },
  ghost: { icon: 'ghost', text: 'gamevoice.ghost' },
  muted: { icon: 'mic_off', text: 'gamevoice.muted' },
};

/** Show state `v` (a key of VOICE, or null: hidden) on `el`; `micOn`: my mic is on. */
export function voiceNote(el, v, micOn) {
  const k = (v === 'all' || v === 'wolf') && !micOn ? 'muted' : v;
  const s = k && VOICE[k];
  el.style.display = s ? '' : 'none';
  el.dataset.voice = k || '';
  if (s) put(el, s.icon, t(s.text));
}
